import React from "react";

import { cloneDeep } from "lodash";
import { HalfDayQualify } from "./presenceModal";
import moment from "moment";
import { get } from "../../utils/utils";

const DayQualification = ({ day, ...props }) => {
  const attendances = day.attendances || {};
  const afternoon = attendances.afternoon || {};
  const morning = attendances.morning || {};

  return (
    <div className="my-5 mx-5" key={day.date}>
      <div className="font-bold text-lg">{day.date}</div>
      <HalfDayQualify data={morning} label="Présence matin" {...props} />
      <HalfDayQualify data={afternoon} label="Présence après-midi" {...props} />
    </div>
  );
};

export default function ValidateWeekAttendance({
  cutoffDate,
  updateAttendance,
  validateAttendancesWeek,
  indexWeek,
  days = [],
  closeModal,
  token,
  absenceTypes,
  userRoleId
}) {
  return (
    <div>
      <div className="flex justify-between overflow-auto">
        {days.map((day, dayIndex) => (
          <DayQualification
            indexSelected={indexWeek}
            dayIndex={dayIndex}
            day={day}
            key={day.date}
            token={token}
            absenceTypes={absenceTypes}
            updateAttendance={updateAttendance}
            userRoleId={userRoleId}
          />
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <div
          className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full p-btn-grey text-white"
          onClick={closeModal}
        >
          Annuler
        </div>
        <div
          className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-green-400 text-white"
          onClick={() => {
            let daysToMap = cloneDeep(days);

            if (moment(cutoffDate).isBetween(days[0].date_iso, days[days.length - 1].date_iso)) {
              const indexItem = days.findIndex(item => moment(item.date_iso).isSame(cutoffDate));
              const daysCopy = cloneDeep(days);

              daysToMap = daysCopy.splice(indexItem);
            }
            closeModal();
            validateAttendancesWeek({
              _ids: daysToMap
                .map(day => {
                  const attendances = day.attendances || {};
                  const morning = attendances.morning || {};
                  const afternoon = attendances.afternoon || {};
                  return [morning._id, afternoon._id];
                })
                .flat()
                .filter(id => id),
              indexWeek: indexWeek,
              currentDate: get([0, "date_iso"], days)
            });
            // api
            //   .attendances()
            //   .validate(token, {
            //     _ids: days
            //       .map(day => {
            //         const attendances = day.attendances || {};
            //         const morning = attendances.morning || {};
            //         const afternoon = attendances.afternoon || {};
            //         return [morning._id, afternoon._id];
            //       })
            //       .flat()
            //       .filter(id => id)
            //   })
            //   .then(result => {
            //     Modal.success({ title: "Succès", content: `Semaine validée` });
            //   })
            //   .catch(e =>
            //     Modal.error({
            //       title: `Erreur`,
            //       content: `La semaine n'a pu être validée`
            //     })
            //   )
            //   .finally(fetchData);
          }}
        >
          Valider les présences
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/modules/presence/presence/modals/ValidateWeekAttendance.js